import script from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MainLayout.vue?vue&type=style&index=0&id=0904bb66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0904bb66"]])

export default __exports__